import { ListSubheader, MenuItem } from "@mui/material";
import {
  CarSelectField,
  CarSelectFieldProps,
  CarSelectOptionGroup,
} from "./Inputs";
import { CarCheckboxOnly } from "./Checkbox";

interface CarMultiSelectProps<V extends number | string>
  extends Omit<CarSelectFieldProps, "value" | "onChange"> {
  value: V[];
  onChange: (value: V[]) => void;
  groups: CarSelectOptionGroup<V>[];
}

export function CarMultiSelect<V extends number | string>({
  value,
  onChange,
  groups,
  ...props
}: CarMultiSelectProps<V>) {
  const handleChange = (value: V[]) => {
    if (!Array.isArray(value)) {
      console.log(`CarMultiSelect.handleChange`, value);
      return;
    }
    onChange(value);
  };

  const selectedOptions = groups
    .flatMap((i) => i.items)
    .filter((o) => value.includes(o.value));

  return (
    <CarSelectField
      {...props}
      SelectProps={{
        ...props.SelectProps,
        multiple: true,
        renderValue: (v) => selectedOptions.map((i) => i.label).join(", "),
      }}
      value={value as unknown as string}
      onChange={handleChange as unknown as (value?: string) => void}
    >
      {groups.flatMap((g, groupIdx) => [
        <ListSubheader key={groupIdx}>{g.label}</ListSubheader>,
        g.items.map((o, idx) => (
          <MenuItem key={`${groupIdx}_${idx}`} value={o.value}>
            <CarCheckboxOnly
              size="small"
              checked={value.some((i) => i === o.value)}
            />
            {o.label}
          </MenuItem>
        )),
      ])}
    </CarSelectField>
  );
}
